export const NEW_ADDRESS_OPTION_ID = "__new__";

// Named shipping address shortcuts for the claim form.
// Add or edit entries here — they appear in the address dropdown.
export const SHIPPING_ADDRESS_SHORTCUTS = [];

const RECENT_ADDRESSES_KEY = "arcadeRecentShippingAddresses";
const MAX_RECENT_ADDRESSES = 8;

const hasLocalStorage = () => {
  try {
    return (
      typeof window !== "undefined" && typeof window.localStorage !== "undefined"
    );
  } catch {
    return false;
  }
};

export const formatShippingAddressLabel = (address) => {
  const trimmed = (address || "").trim();
  if (!trimmed) return "Address";
  return trimmed
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean)
    .join(", ");
};

export const getRecentShippingAddresses = () => {
  if (!hasLocalStorage()) return [];
  try {
    const raw = window.localStorage.getItem(RECENT_ADDRESSES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter(
        (item) => item && typeof item.address === "string" && item.address.trim()
      )
      .map((item, index) => {
        const address = item.address.trim();
        return {
          id: item.id || `recent-${index}`,
          label: formatShippingAddressLabel(address),
          address,
        };
      });
  } catch {
    return [];
  }
};

export const rememberShippingAddress = (address) => {
  const trimmed = (address || "").trim();
  if (!trimmed || !hasLocalStorage()) return;

  const existing = getRecentShippingAddresses().filter(
    (item) => item.address !== trimmed
  );
  const next = [
    {
      id: `recent-${Date.now()}`,
      label: formatShippingAddressLabel(trimmed),
      address: trimmed,
    },
    ...existing,
  ].slice(0, MAX_RECENT_ADDRESSES);

  try {
    window.localStorage.setItem(RECENT_ADDRESSES_KEY, JSON.stringify(next));
  } catch {
    // Ignore storage failures
  }
};

export const buildShippingAddressOptions = (extraAddresses = []) => {
  const seen = new Set();
  const options = [];

  const pushUnique = (item) => {
    if (!item?.address) return;
    const address = item.address.trim();
    const key = address.toLowerCase();
    if (!key || seen.has(key)) return;
    seen.add(key);
    options.push({
      id: item.id,
      label: formatShippingAddressLabel(address),
      address,
    });
  };

  SHIPPING_ADDRESS_SHORTCUTS.forEach(pushUnique);
  getRecentShippingAddresses().forEach(pushUnique);
  extraAddresses.forEach((address, index) => {
    if (typeof address === "string") {
      pushUnique({ id: `claim-${index}`, address });
    } else {
      pushUnique(address);
    }
  });

  return options;
};
